import { Link } from '@report/router';
import { ArrowBackRoundedIcon, Button, PageHeader, Text } from '@shared/components';

export default function QuestionnaireReportPageHeader() {
  return (
    <PageHeader
      title='รายงานสรุปผลแบบสอบถามหลังการสอบ'
      linkAdornment={
        <Button
          variant='text'
          component={Link}
          to='/reports'
          sx={{
            p: 0,
            m: 0,
            justifyContent: 'flex-start',
            color: (theme) => theme.palette.text.secondary,
          }}
          startIcon={<ArrowBackRoundedIcon />}
        >
          Back
        </Button>
      }
      subtitleSection={
        <Text variant='body2' color='text.secondary'>
          สรุปคำตอบแบบสอบถามของผู้เข้าสอบ พร้อมอัตราการผ่านและคะแนนเฉลี่ยในแต่ละคำตอบ
        </Text>
      }
    />
  );
}
